
export const SkillsData = [

  // =========================
  // Enterprise Application Development
  // =========================
  {
    name: 'Enterprise Web Application Development',
    percentage: 95,
    className: 'bg-primary',
  },
  {
    name: 'Laravel',
    percentage: 90,
    className: 'bg-danger',
  },
  {
    name: 'REST API Development',
    percentage: 90,
    className: 'bg-success',
  },
  {
    name: 'API Integration',
    percentage: 90,
    className: 'bg-info',
  },
  {
    name: 'Database Design',
    percentage: 90,
    className: 'bg-warning',
  },
  {
    name: 'MySQL',
    percentage: 90,
    className: 'bg-danger',
  },

  // =========================
  // Server & Infrastructure
  // =========================
  {
    name: 'Linux Server Management (VPS)',
    percentage: 90,
    className: 'bg-dark',
  },
  {
    name: 'Web Server (Nginx & Apache) Configuration',
    percentage: 90,
    className: 'bg-info',
  },
  {
    name: 'Domain & Hosting Management',
    percentage: 90,
    className: 'bg-dark',
  },
  {
    name: 'aaPanel Configuration',
    percentage: 90,
    className: 'bg-info',
  },

  // =========================
  // Frontend Development
  // =========================
  {
    name: 'React JS',
    percentage: 75,
    className: 'bg-info',
  },
  {
    name: 'JavaScript',
    percentage: 85,
    className: 'bg-danger',
  },
  {
    name: 'Bootstrap',
    percentage: 85,
    className: 'bg-primary',
  },
  {
    name: 'jQuery',
    percentage: 80,
    className: 'bg-warning',
  },

  // =========================
  // Core Web Technologies
  // =========================
  {
    name: 'PHP',
    percentage: 80,
    className: 'bg-dark',
  },
  {
    name: 'CSS',
    percentage: 90,
    className: 'bg-success',
  },
  {
    name: 'HTML',
    percentage: 95,
    className: '',
  },

];

